import { rangePresets } from '@crm/utils'
import { useLocales } from '@shared/locales'

export const useRangePresets = () => {
  const { t } = useLocales()

  return {
    rangePresets: rangePresets?.map(({ label, value }) => ({
      value,
      label: t(`filter.${label}`)
    }))
  }
}
